import $ from 'jquery';
import Component from "../models/Component";
import throttle from 'lodash.throttle';
import {$Doc, $Win} from "../utils/jQueryGlobals";

export default class ExtendBg extends Component {
  constructor(element, context) {
    super(element, context);
    this.c = null;
    this.l = null;
    this.e = null;
    $Win.on('resize', throttle(() => this.update(), 100));
    $(() => this.update());
  }

  get container() {
    if (this.c === null) {
      this.c = this.element.closest('.block-grid').first();
    }
    return this.c;
  }

  get layout() {
    if (this.l === null) {
      this.l = this.element.closest('.block-layout').first();
    }
    return this.l;
  }

  get col() {
    if (this.e === null) {
      this.e = this.element.parent();
    }
    return this.e;
  }

  getElementBorders(elem) {
    const offset = elem.offset();
    const top = offset.top,
      left = offset.left,
      right = $Doc.width() - left - elem.outerWidth(),
      bottom = $Doc.height() - top - elem.outerHeight();
    return {top, right, bottom, left}
  }

  update() {
    const elementBorders = this.getElementBorders(this.col);
    const containerBorders = this.getElementBorders(this.container);
    const layoutBorders = this.getElementBorders(this.layout);
    const css = {};
    $.each(elementBorders, (border, value) => {
      if (value <= containerBorders[border]) {
        css[border] = Math.floor(layoutBorders[border] - value);
      } else {
        css[border] = 0;
      }
    });
    this.element.css(css);
  }
}
